<template>
  <v-form
    id="signInForm"
    ref="signInForm"
  >
    <v-card-text>
      <PolteqTextField
        v-model="username"
        field-id="usernameField"
        :label="i18n.t('fields.username')"
        icon="mdi-email-outline"
        type="email"
        autocomplete="username"
        :rules="[rules.required]"
        @keyup.enter="signIn(username, password)"
      />
      <PolteqTextField
        v-model="password"
        field-id="passwordField"
        :label="i18n.t('fields.password')"
        icon="mdi-lock-outline"
        type="password"
        autocomplete="current-password"
        :rules="[rules.required]"
        @keyup.enter="signIn(username, password)"
      />
    </v-card-text>
    <v-card-text style="text-align: end">
      <PolteqButton
        button-id="loginButton"
        icon="mdi-login-variant"
        :button-text="i18n.t('buttons.signin')"
        @click="signIn(username, password)"
      />
      <br>
      <PolteqButton
        button-id="forgotPasswordButton"
        icon="mdi-lock-question"
        :button-text="i18n.t('texts.forgotpassword')"
        @click="NavigationHelper.openForm(router, Forms.FORGOT_PASSWORD)"
      />
    </v-card-text>
  </v-form>
</template>

<script lang="ts" src="./SignInForm.ts" />
